import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartColumn = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M2 14H14",
			stroke: "currentColor",
			strokeWidth: 1.4,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 10V14",
			stroke: "currentColor",
			strokeWidth: 1.4,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 2V14",
			stroke: "currentColor",
			strokeWidth: 1.4,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 7V14",
			stroke: "currentColor",
			strokeWidth: 1.4,
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgChartColumn);
export default ForwardRef;
